<template>

  <breadcrumb :links="{'/': 'Home', '/stazioni': 'Stazioni', 'current': station.name}"></breadcrumb>

  <div id="meteo_station" class="main_container page">

    <div class="section section_even">
      <div class="container-xl">
        <h1 class="station_title">{{station.name}} 
          <div class="station_slmm">Quota stazione: {{station.alt}} m</div>
        </h1>
        <div class="main_title_note">Misure automatiche non validate, tempi riferiti all'ora locale</div>
      </div>
    </div>

    <div class="section section_odd">
      <div class="container-xl">
        <h2>Sensori principali</h2>
        <div v-if="loader" class="loader loading"><div class="lds-dual-ring"></div></div>
        <div class="row">
          <template v-for="sensor in station.sensors">
            <router-link :to="{name: 'misure', params: {station_id: station.id, sensor_id: sensor.id}}" v-if="top_sensors.indexOf(sensor.code) >= 0 && sensor.measures.length > 0" v-bind:key="sensor.code" class="col-xl-6 station_sensor_badge">
              <div class="measure_title">{{sensor.name}}</div>
              <div class="row g-0 measure_row">
                <div class="col-sm-6 measure_text">
                  <div class="measure_value">{{formatMeasure(sensor.measures[sensor.measures.length - 1].value, sensor.decimals)}} <small>{{sensor.unit}}</small></div>
                  <div class="measure_dt">{{convertTime(sensor.measures[sensor.measures.length - 1].dt)}}</div>
                </div>
                <div class="col-sm-6 measure_graph">
                  <mini-chart :sensor="sensor" :day_stops="day_stops"/>
                  <div class="measure_dt">Andamento 72 ore</div>
                </div>
              </div>
            </router-link>
          </template>
        </div>
      </div>
    </div>

    <div class="section section_even" v-if="p_sensor">
      <div class="container-xl">
        <h2>Precipitazioni cumulate</h2>
        <div class="row">
          <template v-for="(measure, index) in p_sensor.measures" v-bind:key="index">
            <div class="col-xl-3 station_sensor_badge">
              <div class="measure_title">{{p_sensor.name}}</div>
              <div class="measure_text measure_row">
                <div class="measure_value">{{formatMeasure(measure.value, p_sensor.decimals)}} <small>{{p_sensor.unit}}</small></div>
                <div class="measure_dt">{{convertTime(measure.dt)}}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="section section_odd" v-if="station.sensors && station.sensors.filter(sensor => top_sensors.indexOf(sensor.code) < 0 && p_sensors.indexOf(sensor.code) < 0).length > 0">
      <div class="container-xl">
        <h2>Altri sensori</h2>
        <div class="row">
          <template v-for="sensor in station.sensors">
            <router-link :to="{name: 'misure', params: {station_id: station.id, sensor_id: sensor.id}}" v-if="top_sensors.indexOf(sensor.code) < 0 && p_sensors.indexOf(sensor.code) < 0 && sensor.measures.length > 0" v-bind:key="sensor.code" class="col-xl-3 station_sensor_badge">
              <div class="measure_title">{{sensor.name}}</div>
              <div class="measure_text measure_row">
                <div class="measure_value">{{formatMeasure(sensor.measures[sensor.measures.length - 1].value, sensor.decimals)}} <small>{{sensor.unit}}</small></div>
                <div class="measure_dt">{{convertTime(sensor.measures[sensor.measures.length - 1].dt)}}</div>
              </div>
            </router-link>
          </template>
        </div>
      </div>
    </div>

  </div>

  <app-footer></app-footer>

</template>

<style lang="scss" scoped>
  .station_title {
    margin-bottom: 5px !important;
    padding-bottom: 0;
  }
  .main_title_note {
    font-size: 0.8em;
    font-style: italic;
    margin-bottom: 10px;
  }
  .section {
    margin-bottom: 20px;
    padding-top: 20px;
  }
  .station_slmm{
    font-weight: normal;
    font-size: 0.5em;
  }
  .station_sensor_badge {
    margin-bottom: 60px;
    text-decoration: none;
    .measure_title, .measure_dt {
      font-variant: small-caps;
      text-align: center;
      display: block;
      color: #eee;
      background-color: #0067b1;
      font-weight: bold;
      font-size: 1.0em;
    }
    .measure_title {
      font-size: 1.2em;
    }
    .measure_value {
      text-align: center;
      color: #0067b1;
      background-color: #eee;
      font-weight: bold;
      padding-top: 3px;
      font-size: 63px;
      height: 100px;
      small {
        font-size: 25px;
      }
    }
    .measure_graph {
      .mini_chart {
        background-color: #eee !important;
      }
    }
    .measure_row {
      border-left: solid 1px #0067b1;
      border-right: solid 1px #0067b1;
    }
  }
  a.station_sensor_badge {
    &:hover {
      .measure_row, .measure_title {
        border-left: solid 2px #F06D16;
        border-right: solid 2px #F06D16;
      }
    }
  }

</style>

<script>
  import MonitorApi from '@/services/MonitorApi';
  import MiniChart from '@/components/MiniChart.vue'
  import Labels from '@/utils/labels';
  import AppFooter from '@/app-footer.vue'
  import Breadcrumb from '@/components/Breadcrumb'

  export default {
    name: "station",
    mixins: [Labels],
    components: { MiniChart, AppFooter, Breadcrumb},
    data: function() {
      return {
        loader: true,
        station: [],
        top_sensors: ['T', 'Tm', 'P', 'Vv', 'Dv', 'U', 'B', 'RG', 'N', 'Q_tot', 'IDRO', 'IDRO_2', 'IDRO_3', 'Q_1'],
        ignore_sensors: ['DvMax', 'VvVett', 'DvVett', 'Prec_5_min', 'MISxG', 'RR', 'Prec_60_min', 'Prec_3_ore', 'Prec_6_ore', 'Prec_12_ore', 'Prec_24_ore', 'Prec_48_ore'],
        p_sensors: ['P_1h'],
        p_sensor: null,
        day_stops: []
      }
    },
    mounted: async function() {
      this.station = await MonitorApi.getStation(this.$route.params.id);
      await MonitorApi.getMeasuresForStation(this.station, this.top_sensors, [], 72);
      const measures = this.station.sensors[0].measures;
      this.day_stops = measures.flatMap((measure, i) => this.convertOnlyTime(measure.dt) == '00:00:00' ? i/(measures.length-1) : []);
      this.loader = false;
      await MonitorApi.getMeasuresForStation(this.station, this.p_sensors, [], 4);
      await MonitorApi.getMeasuresForStation(this.station, [], this.top_sensors + this.ignore_sensors + this.p_sensors, 1);
      this.p_sensor = this.station.sensors.filter(sensor => this.p_sensors.indexOf(sensor.code) >= 0)[0]
    }
  }
  </script>